import { RegionType } from "../../module/map/analysis";
import { ResponseType, Gateway } from "./Gateway";

class GeojsonGateway extends Gateway {
    protected readonly _contextPath = "geojson";
    protected readonly _pathParams?: { [key: string]: string; };
    protected readonly _processParams?: { [key: string]: string; };

    public async reqRegionData(name: RegionType): Promise<ResponseType> {
        return await this.requestResource(undefined, `${name}_simple.geojson`);
    }
}

export { GeojsonGateway };
